import React, { useEffect, useState } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import imageUrlFor from '@helpers/imageUrlFor';
import Faq from '@components/Faq';
import ContactBlock from '@components/ContactBlock';
import SEO from '@components/seo';
import FindRepresentative from '@src/account/FindRepresentative';
import Link from '@src/utility/Link';
import { Accordion } from 'react-accessible-accordion';
import CareerItem from '@src/components/CareerItem';

const Careers = () => {
  const [careers, setCareers] = useState([]);

  useEffect(() => {
    getCareerData();
  }, []);

  const getCareerData = async () => {
    try {
      const apiUrl = 'https://rbw.pinpointhq.com/jobs.json';
      const response = await fetch(apiUrl);
      const data = await response.json();
      setCareers(data.data);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <div>
      <div className=" wrapper sm-down:px-0 py-20">
        <h2 className="type-sans-630 sm-down:mb-10 sm-down:ml-6">
          Current Openings
        </h2>
        <div>
          {/* Table header div */}
          <div className="sm:grid grid-cols-9 p-6 gap-x-10 hidden">
            <p className="type-sans-140 text-mono-600 col-span-3"></p>
            <p className="type-sans-140 text-mono-600 col-span-2">Location</p>
            <p className="type-sans-140 text-mono-600 col-span-2">Department</p>
            <p className="type-sans-140 text-mono-600 col-span-2">
              Employment type
            </p>
          </div>

          <Accordion allowZeroExpanded className="type-sans-230 sm-down:mb-8">
            {careers.map((job, index) => (
              <CareerItem uuid={index + ''} data={job} key={index} />
            ))}
          </Accordion>
        </div>
      </div>
    </div>
  );
};

export default Careers;
